// extracted by mini-css-extract-plugin
module.exports = {"historyListItem":"styles_historyListItem__2G6ns","active":"styles_active__30Pqx","dot":"styles_dot__17NFX","icon":"styles_icon__2h3oz","date":"styles_date__12P9c"};